import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";

const UnitsTableOnMapView = ({ headers = [],columns=[], rows = [], loading = false, onSort,
  sortConfig,
  headerKeyMap }) => {
  const theme = useTheme();
  return (
    <Box sx={{ flex: 1, overflow: "hidden" }}>
      <TableContainer sx={{ height: "100%" }}>
        <Table stickyHeader>
          <TableHead sx={{ backgroundColor: theme.palette.grey[100] }}>
            <TableRow>
              {headers.map((head) => (
            <TableCell
              key={head}
              onClick={() => onSort(headerKeyMap[head])}
              sx={{ cursor: "pointer", fontWeight: 600 }}
            >
              {head}
              {sortConfig?.column === headerKeyMap[head] &&
                (sortConfig?.direction === "asc" ? " ↑" : " ↓")}
            </TableCell>
          ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={headers.length} align="center">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 120,
                      gap: 1,
                    }}
                  >
                    <CircularProgress color="#60a5fa" size={24} />
                    <Typography variant="body2">Loading data...</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : rows && rows.length > 0 ? (
              rows.map((row, i) => (
                <TableRow
                  key={i}
                  hover
                  sx={{
                    backgroundColor: i % 2 === 0 ? "#2f3136" : "#3a3c43",
                    "&:hover": {
                      backgroundColor: "#4a4d54",
                    },
                  }}
                >
                  {columns.map((col) => (
                <TableCell key={col}>{row[col]}</TableCell>
              ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={headers.length}
                  style={{ textAlign: "center", padding: "12px" }}
                >
                  No data available in table
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default UnitsTableOnMapView;
